export default function getResource(label, vars = []) {
    const resources = {
        description: 'Sorry, this storefront is not yet available. Please check back soon. Shop beauty at Sephora in the meantime.',
        ctaText: 'Shop Now'
    };

    return resources[label];
}
